import Anchor from "./schedule/anchor.es6";

const anchor = new Anchor();
